import { Language } from './base';

const pdash = () => import('../translations/pdash/ko-KR.json');
const webActivities = () => import('../translations/web-activities/ko-KR.json');
const rdashTranslatables = () => import('../translations/rdash-translatables/ko-KR.json');

export default new Language({
    code: 'ko-KR',
    locale: 'ko',
    localName: '한국어',
    englishName: 'Korean',
    territory: 'KR',
    timezones: ['Asia/Seoul'],
    notLoadedNamespaces: { pdash, webActivities, rdashTranslatables },
});
